import * as React from 'react';
import { Subtract } from 'utility-types';

export interface InjectedPublishedConnectionTableSpaceServiceInjectorProps {
}

export interface PublishedConnectionTableSpaceServiceInjectorProps {
  readonly publishedConnectionTableId: string;
}

export function withPublishedConnectionTableSpaceServiceInjector<P extends InjectedPublishedConnectionTableSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function PublishedConnectionTableSpaceServiceInjector(
    props: Subtract<P, InjectedPublishedConnectionTableSpaceServiceInjectorProps> & PublishedConnectionTableSpaceServiceInjectorProps
  ) {

    return <Component
      {...props as unknown as P}
    />;
  };
}